import { useTranslation } from 'react-i18next';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import type { IIntegrationUIOption } from '@feathr/components';

import { useLazyOptions } from '../../useLazyOptions';

/** The integration's solicit codes as select options, loaded the first time `enabled` is true. */
export function useSolicitCodeOptions(
  integration: BlackbaudRaisersEdgeIntegration,
  enabled: boolean,
): readonly IIntegrationUIOption[] | undefined {
  const { t } = useTranslation();

  async function load(): Promise<IIntegrationUIOption[]> {
    const response = await integration.getSolicitCodes();
    return (response?.solicit_codes ?? []).map((code) => ({ id: code, name: code }));
  }

  return useLazyOptions({
    enabled,
    errorLabel: (error) => t('Failed to load solicit codes:\n{{- error}}', { error }),
    load,
  });
}
